export const freshdeskScript = (lang: string) => `
	window.fwSettings={
	'widget_id':77000003870,
	'locale': '${lang}'
	};
	!function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()`

export const freshdeskSrc =
  "https://euc-widget.freshworks.com/widgets/77000003870.js"
